
function localvariantValue(){
   var region = $(".product-variant-region-selection .selected").attr('data-region');
   //console.log("selected region::", region);
  if (region == 'product-variant-region__it'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.it_size').addClass('selected_region');
  }
  else if (region == 'product-variant-region__uk'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.uk_size').addClass('selected_region');
  }
  else if (region == 'product-variant-region__us'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.us_size').addClass('selected_region');
  }
  else if (region == 'product-variant-region__eu'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.eu_size').addClass('selected_region');
  }
}

$('body').on('click', '.product-variant-region__Selector', function() {
  $('.product-variant-region__Selector').removeClass('selected');
  $(this).addClass('selected');
  var region = $(this).attr('data-region');
  // console.log("region=",region);
  if (region == 'product-variant-region__it'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.it_size').addClass('selected_region');
  }
  else if (region == 'product-variant-region__uk'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.uk_size').addClass('selected_region');
  }
  else if (region == 'product-variant-region__us'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.us_size').addClass('selected_region');
  }
  else if (region == 'product-variant-region__eu'){
    $('.size_value').hide();
    $('.size_value').removeClass('selected_region');
    $('.eu_size').addClass('selected_region');
  }
});

$( document ).ready(function() {
  $(".product-variant-region__uk_js").trigger("click");
});